import { useState, useEffect } from "react";
import { apiFetch } from "../../../context/AuthContext";

/**
 * useDashboardStats — one call to /employees/dashboard-stats.
 *
 * The endpoint computes every dashboard number from the SAME employee set
 * getEmployeesByVisibility returns for this caller, so a full admin sees
 * client-wide stats while a promoted user only sees their granted scope.
 * Consumers treat `stats` as an override: when null (endpoint failed),
 * the legacy per-endpoint values keep the dashboard working.
 */
const useDashboardStats = (BASE_URL) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const clientName = (localStorage.getItem("clientName") || "").trim();
        const query = clientName ? `?clientName=${encodeURIComponent(clientName)}` : "";
        const res = await apiFetch(`${BASE_URL}/employees/dashboard-stats${query}`, {
          method: "GET",
        });
        const data = await res.json().catch(() => ({}));
        if (!cancelled && res.ok && data?.success && data?.stats) {
          setStats(data.stats);
        }
      } catch (err) {
        console.warn("dashboard-stats failed, falling back to legacy endpoints", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [BASE_URL]);

  return { stats, loading };
};

export default useDashboardStats;
